
import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { runFlowTaskResume } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions} from '../utils/FlowTaskActionUtils';

export const RunFlowTaskResumeAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksResume,
  translateName: Messages.runFlowTasksResumeAction,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[]) => {
    const singleSuspendedItem = targetItems.length === 1 && targetItems[0].suspended;
    return targetItems.length !== 1 || (singleSuspendedItem && userHasManageRunFlowTaskPermissions(availableActions));
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskResume(targetItems)
};
